import React from 'react';
import PropTypes from 'prop-types';

const EditorHyperlink = ({ children }) => {
  return <span className="gx-text-primary">{children}</span>;
};

export default EditorHyperlink;

EditorHyperlink.propTypes = {
  children: PropTypes.node,
};
